import confirm from '../../../utils/confirm.jsx';
import addError from '../../../utils/error.jsx';

export function request(id, accountId) {
    return confirm('Are you sure that you want to cancel this bet?', {
        type: 'BETS_CANCEL_BET_REQUEST',
        accountId,
        id
    });
}

export function error(id, errors) {
    addError(errors);

    return {
        type: 'BETS_CANCEL_BET_ERROR',
        errors,
        id
    };
}

export function finish(id, data) {
    return {
        type: 'BETS_CANCEL_BET_FINISH',
        data,
        id
    };
}
